import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Heading,
  Button,
  Flex,
  Text,
  Image,
  Spinner,
  Center,
  Alert,
  AlertIcon,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from "@chakra-ui/react";
import { secureFetch } from "../data/secureFetch";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function VerifyEmail() {
  const query = useQuery();
  const token = query.get("token");
  const [verificationStatus, setVerificationStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure(); // Success modal

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await secureFetch(
          `/api/users/verify-email?token=${token}`
        );
        if (response.ok) {
          setVerificationStatus("success");
          onOpen(); // Open success modal
        } else {
          throw new Error("Invalid or expired token.");
        }
      } catch (err) {
        setError(err.message);
        setVerificationStatus("error");
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      verifyEmail();
    } else {
      setError("No token provided.");
      setLoading(false);
    }
  }, [token, onOpen]);

  if (loading) {
    return (
      <Center>
        <Spinner />
      </Center>
    );
  }

  return (
    <>
      {/* Logo and Branding */}
      <Flex justifyContent="center" alignItems="center" mt={4} mb={4}>
        <Image
          src="../../logoWithTextNoBg.png"
          height={100}
          width={400}
          alt="PurelyGive Logo"
          // boxSize="80px"
        />
      </Flex>

      <Box
        p={6}
        pt={8}
        maxW="600px"
        mx="auto"
        borderWidth={{ base: "0", md: "1px" }}
        mt={4}
        borderRadius={{ base: "0", md: "lg" }}
        boxShadow={{ base: "none", md: "md" }}
      >
        {error && (
          <Alert status="error" mb={4}>
            <AlertIcon />
            {error}
          </Alert>
        )}

        {!error && verificationStatus === "success" && (
          <>
            <Heading mb={6}>Email Verified</Heading>
            <Text mb={4}>
              Thank you for verifying your email! Your account is now activated,
              and you can start using PurelyGive.
            </Text>

            <Button
              colorScheme="orange"
              onClick={() => {
                navigate("/login");
              }}
            >
              Go to Login
            </Button>
          </>
        )}
      </Box>

      {/* Success Modal */}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Email Verification Successful</ModalHeader>
          <ModalBody>
            Your email has been verified. You can now access all the features of
            PurelyGive.
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="orange" onClick={() => navigate("/login")}>
              Go to Login
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Flex alignItems="center" justifyContent="center" mt={4} mb={6}>
        <Image
          src="../../logoWithTextNoBg.png"
          height={"40px"}
          width={180}
          alt="PurelyGive Logo"
          display="inline"
          // boxSize="20px"
          mr={1}
        />

        <Text fontSize="sm" color="gray.500" ml={4} mr={4}>
          |
        </Text>
        <Text fontSize="sm" color="gray.500">
          <a href="https://PurelyGive.com">Back to our website</a>
        </Text>
        <Text fontSize="sm" color="gray.500" ml={4} mr={4}>
          |
        </Text>
        <Text fontSize="sm" color="gray.500">
          Powered by Stripe
        </Text>
      </Flex>
    </>
  );
}

export default VerifyEmail;
